export interface PublicJob {
  id: number;
  public_job_id: string;
  job_code: string;
  title: string;
  location: string;
  work_mode: string;
  employment_type: string;
  experience_required: string;
  summary: string;
  skills: string[];
  salary_range: { min: number; max: number; currency: string } | null;
  posted_date: string;
  application_deadline: string | null;
}

export interface PublicCareerSettings {
  company_id: string;
  company_type: string;
  company_name: string;
  company_logo_url: string | null;
  banner_image_url: string | null;
  primary_color: string;
  about_company: string;
  social_links: Record<string, string>;
}

export const hexAlpha = (hex: string | undefined, alpha: number) => {
  if (!hex) return `rgba(79, 70, 229, ${alpha})`;
  try {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    if (isNaN(r) || isNaN(g) || isNaN(b)) throw new Error("Invalid hex");
    return `rgba(${r},${g},${b},${alpha})`;
  } catch {
    return `rgba(79, 70, 229, ${alpha})`;
  }
};
